/* eslint-disable */
/* eslint-disable no-alert, no-console */
/*
outerAspectRatios = [
    {breakpoint: 0, ratio: 4/3},
    {breakpoint: 768, ratio: 16/9},
]
*/
function initVideoObjectFit (videoElement, containerElement = false, containerElementArs = false) {

    if (!containerElement) {
        containerElement = window;
        containerElementArs = false;
    }

    window.addEventListener('resize', () => {
        window.setTimeout(() => {
            videoObjectFit(videoElement, containerElement, containerElementArs);
         }, 100);
    });

    videoObjectFit(videoElement, containerElement, containerElementArs);

}

function getRatioFromBreakpoint(element, aspectRatios) {
    const windowWidth = window.innerWidth;
    let ratio = element.offsetHeight / element.offsetWidth; // element Ratio is default
    aspectRatios.forEach((aspectRatio) => {
        if (aspectRatio.breakpoint <= windowWidth) {
            if (aspectRatio.ratio) {
                ratio = aspectRatio.ratio;
            } else {
                ratio = element.offsetHeight / element.offsetWidth;
            }
        }
    });
    return ratio;
}

function getContainerWidth(containerElement) {
    if (containerElement === window) {
        return document.documentElement.clientWidth; // exclude scrollbars
    } else {
        return containerElement.offsetWidth;
    }
}

function getContainerHeight(containerElement) {
    if (containerElement === window) {
        return document.documentElement.clientHeight; // exclude scrollbars
    } else {
        return containerElement.offsetHeight;
    }
}

function videoObjectFit(videoElement, containerElement, containerElementArs) {


    let containerElementAr = getContainerHeight(containerElement) / getContainerWidth(containerElement);

    if (containerElementArs) {
        containerElementAr = getRatioFromBreakpoint(containerElement, containerElementArs);
    }

    let videoElementAr = getContainerHeight(videoElement) / getContainerWidth(videoElement);

    if (containerElementAr > videoElementAr) {

        const widthPercent = (containerElementAr / videoElementAr) * 100;
        videoElement.style.width = `${widthPercent}%`;
    } else {
        videoElement.style.width = '100%';
    }

    const transformX = (getContainerWidth(containerElement) - getContainerWidth(videoElement)) / 2;
    const transformY = (getContainerHeight(containerElement) - getContainerHeight(videoElement)) / 2;

    videoElement.style.transform = `translate(${transformX}px, ${transformY}px)`;
}

export { initVideoObjectFit };
